export const createRegExpFromString = (str) => {
    try {
        return new RegExp(str);
    }
    catch (error) {
        console.error("no valid RegExp for ", str);
        return null;
    }
};
//# sourceMappingURL=createRegExpFromString.js.map